import dialogXClose from "../../../../src/images/dialog-x-close.png";
import * as React from 'react';
export default {
  dialogXClose,
  React
};